import { useTranslation } from 'react-i18next';
import { Button, Card, Checkbox, Container, Divider, Icon, Stack, Text, TextInput } from 'shell/components';
import { getUserPreferredFullName } from 'utils/helper';

const Mobile = ({
    currentAssignment,
    studentSubmissionsGroupedByAccountUser,
    filters,
    setFilters,
    checked,
    setChecked,
    sortState,
    getFilterCount,
    onClickBack,
    onClickView,
    resetSubmissions,
    resetCheckedSubmissions,
    exportToCSV,
}) => {
    const { t } = useTranslation('assignment');

    return (
        <Container device={'mobile'}>
            <Stack spacing={5}>
                <Button
                    sx={{ alignSelf: 'flex-start' }}
                    startIcon={<Icon kind={'arrowLeft'} />}
                    variant={'borderless'}
                    onClick={onClickBack}
                >
                    {t('common:controls.back', 'Back')}
                </Button>
                <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                    {currentAssignment.title}
                </Text>
                <Stack spacing={3}>
                    <Stack direction={'row'} spacing={3}>
                        <Button
                            color={'neutral'}
                            startIcon={<Icon kind={'filter'} />}
                            variant={'secondary'}
                            onClick={() => setFilters((current) => ({ ...current, open: true }))}
                        >
                            ({getFilterCount(filters, sortState)})
                        </Button>
                        <TextInput
                            endIcon={<Icon kind={'search'} />}
                            placeholder={t('common:controls.search', 'Search')}
                            value={filters.search}
                            onChange={(e) => setFilters((current) => ({ ...current, search: e.target.value }))}
                        />
                    </Stack>
                    <Button
                        fullWidth
                        startIcon={<Icon kind={'download'} />}
                        variant={'secondary'}
                        tooltip={{
                            component: t('export-feedback-csv', 'Export feedback to a CSV'),
                        }}
                        onClick={exportToCSV}
                    >
                        {t('common:controls.export-to-csv', 'Export to CSV')}
                    </Button>
                    {checked.length > 0 ? (
                        <Button
                            color={'destructive'}
                            startIcon={<Icon kind={'refresh'} />}
                            variant={'secondary'}
                            onClick={resetCheckedSubmissions}
                        >
                            {t('common:controls.reset-drafts', 'Reset Drafts')} ({checked.length})
                        </Button>
                    ) : (
                        <Button
                            color={'destructive'}
                            startIcon={<Icon kind={'refresh'} />}
                            variant={'secondary'}
                            onClick={resetSubmissions}
                        >
                            {t('common:controls.reset-drafts', 'Reset Drafts')}
                        </Button>
                    )}
                </Stack>
                <Stack>
                    <Checkbox
                        checked={
                            studentSubmissionsGroupedByAccountUser.length > 0 &&
                            studentSubmissionsGroupedByAccountUser.every(({ owner_account_id }) =>
                                checked.includes(owner_account_id)
                            )
                        }
                        label={<Text color={'light'}>Select All</Text>}
                        onChange={() => {
                            setChecked(() => {
                                return studentSubmissionsGroupedByAccountUser.every((s) =>
                                    checked.includes(s.owner_account_id)
                                )
                                    ? []
                                    : studentSubmissionsGroupedByAccountUser.map(
                                          ({ owner_account_id }) => owner_account_id
                                      );
                            });
                        }}
                    />
                    <Divider sx={{ mt: 1, mb: 3 }} />
                    <Stack sx={{ pb: 8 }} spacing={3}>
                        {studentSubmissionsGroupedByAccountUser.map((accountUser) => (
                            <Card key={accountUser.owner_account_id}>
                                <Stack sx={{ width: '100%' }} spacing={3}>
                                    <Stack alignItems={'center'} direction={'row'} spacing={2}>
                                        <Checkbox
                                            checked={checked.includes(accountUser.owner_account_id)}
                                            onChange={() => {
                                                setChecked((current) => {
                                                    if (current.includes(accountUser.owner_account_id)) {
                                                        return current.filter(
                                                            (id) => id !== accountUser.owner_account_id
                                                        );
                                                    }
                                                    return [...current, accountUser.owner_account_id];
                                                });
                                            }}
                                        />
                                        <Text component={'p'} variant={'h6'} weight={'semibold'}>
                                            {getUserPreferredFullName(accountUser)}
                                        </Text>
                                    </Stack>
                                    <Divider />
                                    <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                                        <Text color={'light'}>
                                            {t('common:table.drafts-submitted', 'Drafts Submitted')}:{' '}
                                            {accountUser.submissions.length}
                                        </Text>
                                        <Button
                                            disabled={!accountUser.submissions.length}
                                            variant={'borderless'}
                                            onClick={() => onClickView(accountUser)}
                                        >
                                            {t('common:controls.view', 'View')}
                                        </Button>
                                    </Stack>
                                </Stack>
                            </Card>
                        ))}
                    </Stack>
                </Stack>
            </Stack>
        </Container>
    );
};

export default Mobile;
